import { useInfiniteQuery } from '@tanstack/react-query';

import {
  formatInfiniteData,
  getNextPageParam,
} from 'components/helpers/reactQuery';

export function useInfiniteProjectsAssignablePersonnelSearchesQuery({
  params,
  projectId,
  queryOptions,
}) {
  return useInfiniteQuery({
    queryKey: ['projects', projectId, 'assignablePersonnelSearches', params],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.post(
        `/projects/${projectId}/assignable_personnel_searches`,
        { assignable_personnel_search: { ...params, page: pageParam } },
      );

      return response.data;
    },
    getNextPageParam,
    select: (data) =>
      formatInfiniteData({
        data,
        resourceTypes: ['companyRole', 'profilePhoto', 'userCompanyRole'],
      }),
    ...queryOptions,
  });
}
